import moment from "moment";
import React, { useContext, useState } from "react";
import Countdown from "react-countdown";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../App";
import ContdownTimerRender from "../../../../CustomHelper/ContdownTimerRender";
import EnrollAuditionTimer from "./EnrollAuditionTimer";

const SingleEnrollAudition = ({ event }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  let history = useHistory();



  const handleClick = (audition) => {
    console.log("audition")
    console.log(audition)
    const end_date =
      moment(audition?.end_date).format("LL") +
      " " +
      "00:00:00";
    const countDownDate = new Date(end_date).getTime();
    if (countDownDate <= new Date().getTime()) {
      swal("Ops!", "Registration Date End Yet! Please Wait...");
    } else {
      history.push({
        pathname: `/enrolled-auditions-round/${audition?.slug}`,
        state: {
          pending: "pending",
          audition_end_date: audition?.end_date
        },
      });
    }
  };

  return (
    <div class="col-md-6 col-lg-4 mb-3">
      <div
        className="card text-center CardEn"
        onClick={() => handleClick(event.audition)}
      >
        <img src={imageCdnUrl + event.audition?.banner} alt="Img1" />
        <h6 className="fw-bold pt-3 pb-1 EnHead">{event.audition?.title}</h6>
            <Countdown
               date={event.audition?.end_date}
              //date={event.audition?.audition_round[0]?.start_date}
              renderer={ContdownTimerRender}
            />
      </div>
    </div>
  );
};

export default SingleEnrollAudition;
